import React from "react";
import Link from "./Link";
import PropTypes from "prop-types";

const MailToLink = (props) => {
  const mailtoProps = {
    ...props,
    to: `mailto:${props.email}`,
  };
  return <Link {...mailtoProps}>{props.children || props.email}</Link>;
};

MailToLink.propTypes = {
  email: PropTypes.string.isRequired,
};

export default MailToLink;
